import { FunnelFeatureValue } from 'core/feature-flags/config/funnelFeature';

export const DEFAULT_FLOW = 'default_flow';

export const resolveFlowId = (value: FunnelFeatureValue, locale: string): string => {
  const { flow } = value;

  if (typeof flow === 'string') return flow;

  if (flow && typeof flow === 'object') return flow[locale] ?? DEFAULT_FLOW;

  return DEFAULT_FLOW;
};
